import { useEffect, useState } from "react";
import EditorDialog from "./EditorDialog";

const CategoryDialog = ({ open, onClose, suggestions = [], onSubmit }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) setName("");
  }, [open]);

  const submit = (event) => {
    event.preventDefault();
    onSubmit(name);
    if (name.trim()) onClose();
  };

  return (
    <EditorDialog open={open} onClose={onClose} title="افزودن دسته‌بندی">
      <form onSubmit={submit} className="space-y-5 pt-1">
        {suggestions.length > 0 && (
          <div>
            <p className="mb-2 text-sm font-medium text-gray-700">پیشنهادهای مناسب کسب‌وکار شما</p>
            <div className="flex flex-wrap gap-2">
              {suggestions.map((suggestion) => (
                <button
                  key={suggestion}
                  type="button"
                  onClick={() => setName(suggestion)}
                  className={`min-h-10 rounded-xl border px-3 text-sm transition-colors ${name === suggestion ? "border-primary bg-primary/10 text-primary" : "border-gray-200 hover:border-primary/50"}`}
                >
                  {suggestion}
                </button>
              ))}
            </div>
          </div>
        )}
        <label className="block text-sm font-medium text-gray-700">
          نام دسته‌بندی
          <input
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="مثلاً نوشیدنی‌های گرم"
            className="mt-2 w-full rounded-xl border border-gray-200 p-3 outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
          />
        </label>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="min-h-11 rounded-xl border border-gray-200 px-4 text-sm font-medium">انصراف</button>
          <button type="submit" className="min-h-11 rounded-xl bg-primary px-5 text-sm font-bold text-white hover:bg-[#e8731f]">افزودن دسته</button>
        </div>
      </form>
    </EditorDialog>
  );
};

export default CategoryDialog;
